/* Currency picker, mirrored out of the footer. v3.

   The working picker lives at the bottom of the footer and owns everything: the
   time zone guess, the price table, the rk_ccy preference, and a document-level
   click listener bound to `.rk-ccy button`. This file only makes copies of it
   and keeps them honest.

   v1 copied the footer's computed styles onto its copy as inline style, which
   overrode the CSS rule that lights the selected button. The copy froze on
   whichever currency was showing when it was built, and clicking it needed two
   goes to look right. v2 stopped doing that: the `.rk-ccy` rules are not scoped
   to the footer, so a copy is painted by the same stylesheet as the original.
   It also dropped v1's own click handler, because the copy keeps the `rk-ccy`
   class and the footer's document-level listener already covers it — having
   both meant one press ran the handler twice.

   v3 adds a second copy, inside the mobile menu. On a phone the header row is
   replaced by the burger, and the header copy goes with it, so there was no way
   to change currency without scrolling to the bottom of the page. Same clone,
   same stylesheet, same listener; one observer keeps every copy in step with
   the footer.

   Nothing here decides what anything looks like or what a click does. If no
   footer picker is on the page, which is every page without prices, this does
   nothing at all. */
(function () {
  var MATCH = /^[£$€]\s*(GBP|USD|EUR)$/i;

  function label(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function code(el) {
    return (el.getAttribute && el.getAttribute('data-ccy')) ||
           label(el).toUpperCase().slice(-3);
  }

  /* The current markup is `.rk-ccy` with three `button[data-ccy]`. The label
     walk is kept for older footers that predate that. */
  function sourceButtons() {
    var pill = document.querySelector('footer .rk-ccy');
    if (pill) {
      var direct = pill.querySelectorAll('button[data-ccy]');
      if (direct.length >= 2) return [].slice.call(direct);
    }

    var foot = document.querySelector('footer');
    if (!foot) return [];
    var nodes = foot.querySelectorAll('button, a, span, div');
    var seen = {}, unique = [];
    for (var i = 0; i < nodes.length && unique.length < 3; i++) {
      if (!MATCH.test(label(nodes[i]))) continue;
      if (nodes[i].querySelector('button, a')) continue; // a wrapper, not the control
      var key = code(nodes[i]);
      if (seen[key]) continue;
      seen[key] = 1;
      unique.push(nodes[i]);
    }
    return unique;
  }

  /* The nearest element that holds all of them. That is the pill. */
  function pickerRoot(buttons) {
    var node = buttons[0];
    while (node && node !== document.body) {
      var holdsAll = true;
      for (var i = 1; i < buttons.length; i++) {
        if (!node.contains(buttons[i])) { holdsAll = false; break; }
      }
      if (holdsAll) return node;
      node = node.parentElement;
    }
    return null;
  }

  /* Immediately before the Pricing link, so the header row reads
     currency, Pricing, Sign in, Join Rockkt. */
  function headerSlot() {
    var head = document.querySelector('header');
    if (!head) return null;
    var links = head.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (/\/pages\/pricing(\/|$|\?)/.test(links[i].getAttribute('href') || '')) {
        return { parent: links[i].parentNode, before: links[i] };
      }
    }
    return null;
  }

  /* At the end of the burger menu, under the last link. */
  function mobileSlot() {
    var menu = document.getElementById('navMobile') || document.querySelector('.nav-mobile');
    if (!menu) return null;
    return { parent: menu, before: null };
  }

  function controls(root) {
    var direct = root.querySelectorAll('button[data-ccy]');
    if (direct.length >= 2) return [].slice.call(direct);
    var out = [], nodes = root.querySelectorAll('button, a, span, div');
    for (var i = 0; i < nodes.length; i++) {
      if (!MATCH.test(label(nodes[i]))) continue;
      if (nodes[i].querySelector('button, a')) continue;
      out.push(nodes[i]);
    }
    return out;
  }

  var copies = [];   /* [{ pairs: [[original, copy], ...] }, ... ] */

  function makeCopy(root, buttons, slot, cls, aria) {
    if (!slot || !slot.parent) return null;
    if (document.querySelector('.' + cls)) return null;

    var clone = root.cloneNode(true);
    clone.classList.add(cls);
    clone.setAttribute('data-rk-nocc', '');   // never rewrite our own labels
    clone.setAttribute('role', 'group');
    clone.setAttribute('aria-label', aria);

    /* Ids would be duplicated, and any inline style carried over from the
       original would override the stylesheet in exactly the way v1 did. */
    clone.removeAttribute('id');
    clone.removeAttribute('style');
    var all = clone.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      all[i].removeAttribute('id');
      all[i].removeAttribute('style');
    }

    var mine = controls(clone);

    /* Pair each copied control with its original by currency code, so the
       matching survives whatever wrapper markup sits between them. */
    var pairs = [];
    for (var j = 0; j < mine.length; j++) {
      for (var k = 0; k < buttons.length; k++) {
        if (code(mine[j]) !== code(buttons[k])) continue;
        pairs.push([buttons[k], mine[j]]);
        break;
      }
    }

    /* An <a> in an older footer would navigate; a real button will not. */
    for (var m = 0; m < mine.length; m++) {
      if (mine[m].tagName === 'A') mine[m].removeAttribute('href');
      mine[m].style.cursor = 'pointer';
    }

    /* Clicks. A copy that kept the `rk-ccy` class is already covered by the
       footer script's document-level listener, and adding a second handler is
       what made one press count twice in v1. Only an older, differently
       classed footer needs forwarding, and then the click is sent to the
       original rather than reimplemented. */
    if (!clone.classList.contains('rk-ccy')) {
      for (var n = 0; n < pairs.length; n++) {
        (function (original, copy) {
          copy.addEventListener('click', function (ev) {
            ev.preventDefault();
            original.click();
          });
        })(pairs[n][0], pairs[n][1]);
      }
    }

    slot.parent.insertBefore(clone, slot.before);
    copies.push({ pairs: pairs });
    return clone;
  }

  /* Which button is lit is an attribute on the button, not a style, so copying
     that across is the whole of keeping them in step. */
  function mirror() {
    for (var c = 0; c < copies.length; c++) {
      var pairs = copies[c].pairs;
      for (var p = 0; p < pairs.length; p++) {
        var from = pairs[p][0], to = pairs[p][1];
        var pressed = from.getAttribute('aria-pressed');
        if (pressed !== null && to.getAttribute('aria-pressed') !== pressed) {
          to.setAttribute('aria-pressed', pressed);
        }
        if (to.className !== from.className) to.className = from.className;
      }
    }
  }

  var watching = false;

  function build() {
    var buttons = sourceButtons();
    if (buttons.length < 2) return;

    var root = pickerRoot(buttons);
    if (!root) return;

    makeCopy(root, buttons, headerSlot(), 'rk-ccy-top', 'Currency');
    makeCopy(root, buttons, mobileSlot(), 'rk-ccy-mob', 'Currency');
    if (!copies.length) return;

    mirror();

    if (watching) return;
    watching = true;

    /* Follow the footer for the life of the page. An observer rather than a
       timeout: the footer repaints on click and again at 1.5s and 4s as late
       prices arrive, and no fixed delay lines up with all three. */
    if ('MutationObserver' in window) {
      new MutationObserver(mirror).observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-pressed', 'class']
      });
    } else {
      document.addEventListener('click', function () { setTimeout(mirror, 80); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  /* The footer is assembled late on several templates. */
  window.addEventListener('load', function () { setTimeout(build, 500); });
})();
